import React, { useEffect, useRef } from 'react';
import InfoViewText from '../components/InfoViewText/InfoViewText';
import BackLink from '../components/BackLink/BackLink';
import ScratchingHead from '../components/ScratchingHead/ScratchingHead';
import InfoWrapper from '../components/InfoWrapper/InfoWrapper';
import { useLanguageContext } from '../core/locale/LanguageContext';
import Agent from '../lib/assets/agent.svg';
import { useFlag } from '../feature-flags';
import { useAppContext } from '../core/context';
import { errorReasons, viewEvents } from '../core/services/mixpanelEvents';

function ErrorView(): React.ReactNode {
  const context = useAppContext();
  const showNewDesign = useFlag('redesign');
  const languageContext = useLanguageContext();
  const viewLoadedRef = useRef(false);

  useEffect(() => {
    // Deliberately not gated on claims: a failed claims validation is the most common way to end
    // up here, and gating would drop exactly the errors we most need to see.
    if (viewLoadedRef.current) return;
    viewLoadedRef.current = true;
    context.mixpanel?.trackViewLoad(viewEvents.LANDING_PAGE_ERROR_VIEWED, {
      Reason: context.errorReason ?? errorReasons.UNKNOWN,
    });
  }, [context]);

  if (showNewDesign) {
    return (
      <>
        <div className="error-view-illustration-wrapper">
          <img src={Agent} alt="" aria-hidden="true" className="error-view-illustration-image" />
          <BackLink reason="ERROR">{languageContext.getLocalizedText('errorPrimary')}</BackLink>
        </div>
        <div className="error-view-header">
          <h1 className="error-view-heading">{languageContext.getLocalizedText('errorHeader')}</h1>
          <p className="error-view-description">
            {languageContext.getLocalizedText('errorContent').split('\n')}
          </p>
        </div>
      </>
    );
  }

  return (
    <InfoWrapper>
      <InfoViewText
        icon={<ScratchingHead />}
        title={languageContext.getLocalizedText('errorHeader')}
        lines={languageContext.getLocalizedText('errorContent').split('\n')}
        bold={true}
      />
      <BackLink reason="ERROR">{languageContext.getLocalizedText('errorPrimary')}</BackLink>
    </InfoWrapper>
  );
}

export default ErrorView;
